export default "__VITE_ASSET__pDfChi3i__"